import React from 'react'
import { SvgProps } from './SvgProps'
import { svgTransform } from './svgTramsform'

export const NotContractedCircleSvg = ({ size }: SvgProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: svgTransform(size),
      }}
    >
      <rect width="24" height="23" rx="2" fill="#7F7D76" />
    </svg>
  )
}
